// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"334":"c98759e9","791":"7fc0a59d","809":"5eb10943"}[chunkId] + ".js";
};